import { Imu1CompanionAdsInfiniteScroll } from "@elements/Advertisement/variant/AdsCompanion";
import { AdsImu1 } from "@elements/Advertisement/variant/AdsImu";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import { ReactElement } from "react";

export function RenderImu1AdInfiniteScroll(
  adIndex: number,
  sectionName: string,
  pageAdTargetValue: PageAdTargetingTypeEnum,
): ReactElement {
  if (adIndex === 1) {
    return (
      <AdsImu1 sectionName={sectionName} pageAdTargetType={pageAdTargetValue} />
    );
  }

  return (
    <Imu1CompanionAdsInfiniteScroll
      sectionName={sectionName}
      index={adIndex}
      pageAdTargetType={pageAdTargetValue}
    />
  );
}
